import { type ZodSchema, z } from 'zod'

import {
  AUDIT_RUBRIC_RESPONSES_LEVEL,
  AUDIT_RUBRIC_RESPONSES_YES_NO,
  type AuditRubricQuestions,
} from '@/client/services/sessionAudit/types'

const auditRubricResponseLevelSchema = z.enum(AUDIT_RUBRIC_RESPONSES_LEVEL)

const auditRubricResponseYesNoSchema = z.enum(AUDIT_RUBRIC_RESPONSES_YES_NO)

export function auditRubricToSchema(auditRubric: AuditRubricQuestions) {
  const questions = auditRubric.blocks.flatMap(block => block.questions)

  return z.object({
    version: z.literal(auditRubric.version),
    ...Object.fromEntries(
      questions.map(question => {
        let schema: ZodSchema

        if (question.type === 'short-answer') {
          schema = question.minLength != null ? z.string().min(question.minLength) : z.string()
        } else if (question.type === 'yes-no') {
          schema = auditRubricResponseYesNoSchema
        } else {
          schema = auditRubricResponseLevelSchema
        }

        if (!question.required) {
          schema = schema.nullable()
        }

        return [question.slug, schema]
      })
    ),
  })
}
